import React, { Fragment } from "react";

import { EuiBreadcrumbs, EuiSpacer } from "@elastic/eui";

export default function ManualBreadcrumbs() {
  const breadcrumbs = [
    {
      text: "Übersicht",
      href: "/de/Aussenkameras/IN-9808_QFHD/",
    },
    {
      text: "Spezifikationen",
      href: "/de/Aussenkameras/IN-9808_QFHD/Technische_Spezifikationen/",
    },
    {
      text: "Features",
      href: "/de/Aussenkameras/IN-9808_QFHD/Produkt_Features/",
    },
    {
      text: "Installation",
      href: "/de/Aussenkameras/IN-9808_QFHD/Schnell_Installation/",
    },
    {
      text: "Objektivjustage",
      href: "/de/Aussenkameras/IN-9808_QFHD/Objektivjustage/",
    },
    {
      text: "Handbuch",
      href: "/de/Aussenkameras/IN-9808_QFHD/Handbuch/",
    },
    {
      text: "◄ Außenkameras",
      href: "/de/Aussenkameras/",
    },
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-9808 4K UHD Online Benutzerhandbuch Kapitel"
      />
      <EuiSpacer />
    </Fragment>
  );
}
